<template>
  <div class="pc" :class="{ 'pc-feat': featured }">
    <div class="pc-info">
      <div class="pc-name">{{ name }}</div>
      <div class="pc-role">{{ role }}</div>
    </div>
    <button class="pc-btn" @click="$emit('appeal')">
      <i class="fas fa-paper-plane"></i>
      <span>{{ $t('MPAppeal') }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonCard",
  props: {
    name: { type: String, required: true },
    role: { type: String, default: "" },
    photo: { type: String, default: "" },
    featured: { type: Boolean, default: false },
    chipText: { type: String, default: "" },
    avClass: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
.pc {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid #e3e6ee;
  border-radius: 12px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pc:hover {
  border-color: #c8cee0;
  box-shadow: 0 3px 10px rgba(42, 59, 93, 0.06);
}
.pc-feat {
  border-color: #2a3b5d;
}

.pc-av {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 50%;
  object-fit: cover;
  background: #eaedf3;
  display: block;
  flex-shrink: 0;
}

.pc-info {
  flex: 1;
  min-width: 0;
}
.pc-name {
  font-size: 14px;
  font-weight: 700;
  color: #1c2238;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc-role {
  font-size: 12px;
  color: #6b7388;
  margin-top: 2px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pc-btn {
  flex-shrink: 0;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: #2a3b5d;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
}
.pc-btn i {
  font-size: 11px;
}
.pc-btn:hover {
  background: #1f2d4a;
}
.pc-btn:active {
  transform: translateY(1px);
}
</style>
